/**
 * Relative time for the chrome foot ("2h ago" / "2h"). Recomputed on
 * re-render only — no ticker; hover re-renders keep it fresh enough.
 * Spreads straight into CanvasObjectChrome's `when` / `whenShort` props.
 */
export function relativeWhen(iso?: string): {
  when?: string;
  whenShort?: string;
} {
  if (!iso) return {};
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return {};
  const m = Math.floor(ms / 60_000);
  if (m < 1) return { when: "just now", whenShort: "now" };
  if (m < 60) return { when: `${m}m ago`, whenShort: `${m}m` };
  const h = Math.floor(m / 60);
  if (h < 24) return { when: `${h}h ago`, whenShort: `${h}h` };
  const d = Math.floor(h / 24);
  if (d < 7) return { when: `${d}d ago`, whenShort: `${d}d` };
  const w = Math.floor(d / 7);
  return { when: `${w}w ago`, whenShort: `${w}w` };
}
